// extracted by mini-css-extract-plugin
export default {"layout":"protected-route_layout__5RqHm"};